import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kids_baby_gear: FaireCategoryEntity = {
  token: "cat_kids-baby-gear",
  type: "category",
  name: "Baby gear",
  level: 2,
  parentToken: "cat_kids-baby",
  href: "/category/baby-gear",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
